import { $html, $each } from "ekma";

import Body from "./Body";
import Month from "./Month";

export default (body: Body) => $html`
	<div class="viewport">
		<div class="months">
		</div>
	</div>
`;